<p-card>
   <ng-template pTemplate="header">
   </ng-template>
   <div class="row taC">
      <div *ngIf="!conectado && mensajeError === ''">
         <h5 class="customfont1 mT-15">Escanea el codigo QR.</h5>
         <!-- <h5 class="customfont2 mT-15">Su número de WhatsAap esta ahora conectado.</h5> -->
         <h5 class="customfont2 mt-5">Para empezar a enviar y recibir mensajes a través de la plataforma.</h5>
         <!-- <h5 class="customfont3 mT-15">Para operar sin problemas, asegúrese de que su dispositivo WhatsApp permanezca
            en línea correctamente conectado a Internet.</h5>
         <h5 class="customfont3 mt-5">Tenga la seguridad de que si detectamos algún problema, se le notificará por correo
            electrónico..</h5> -->
      </div>
      <div *ngIf="!conectado && mensajeError !== '' && !webhookEnlazado">
         <h5 class="customfont1 mT-15">Error</h5>
         <!-- <h5 class="customfont2 mT-15">Su número de WhatsAap esta ahora conectado.</h5> -->
         <h5 class="customfont2 mt-5">{{mensajeError}}</h5>
         <!-- <h5 class="customfont3 mT-15">Para operar sin problemas, asegúrese de que su dispositivo WhatsApp permanezca
            en línea correctamente conectado a Internet.</h5>
         <h5 class="customfont3 mt-5">Tenga la seguridad de que si detectamos algún problema, se le notificará por correo
            electrónico..</h5> -->
      </div>
      <div *ngIf="conectado">
         <h5 class="customfont1 mT-15">Exito</h5>
         <h5 class="customfont2 mT-15">Su número de WhatsAap esta ahora conectado.</h5>
         <h5 class="customfont2 mt-5">Puedes empezar a enviar y recibir mensajes a través de la plataforma.</h5>
         <h5 class="customfont3 mT-15">Para operar sin problemas, asegúrese de que su dispositivo WhatsApp permanezca
            en línea correctamente conectado a Internet.</h5>
         <h5 class="customfont3 mt-5">Tenga la seguridad de que si detectamos algún problema, se le notificará por correo
            electrónico..</h5>
      </div>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 172 172"
         style=" fill:#000000;">
         <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter"
            stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none"
            font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#1abc9c">
               <path
                  d="M86,6.88c-43.6552,0 -79.12,35.4648 -79.12,79.12c0,43.6552 35.4648,79.12 79.12,79.12c43.6552,0 79.12,-35.4648 79.12,-79.12c0,-43.6552 -35.4648,-79.12 -79.12,-79.12zM86,13.76c39.9368,0 72.24,32.3032 72.24,72.24c0,39.9368 -32.3032,72.24 -72.24,72.24c-39.9368,0 -72.24,-32.3032 -72.24,-72.24c0,-39.9368 32.3032,-72.24 72.24,-72.24zM120.35969,51.55969c-1.13486,0.02237 -2.18564,0.60307 -2.80844,1.55203l-35.09203,51.72765l-25.08109,-23.27375c-0.89676,-0.8629 -2.18961,-1.17423 -3.38088,-0.81414c-1.19126,0.36009 -2.09519,1.33544 -2.36381,2.5506c-0.26862,1.21516 0.13995,2.48065 1.06843,3.30932l30.94656,28.71594l39.60031,-58.35906c0.74064,-1.06125 0.82307,-2.44836 0.21333,-3.58986c-0.60974,-1.1415 -1.8085,-1.84425 -3.10239,-1.81873z">
               </path>
            </g>
         </g>
      </svg> -->
      <div *ngIf="qr === '' && mensajeError === ''" class="loading-indicator">
         <p-progressSpinner [style]="{'width':'40px', 'height':'40px'}"></p-progressSpinner>
         <p [style]="{'width':'40px', 'height':'40px'}"> Cargando QR...</p>
     </div>
      <div *ngIf="qr !== '' && mensajeError === '' && !conectado">
         <img width="200" [src]="qr" alt="">
      </div>
      <hr class="custHr" />
      <!-- <div class="row">
         <span>
            <button pButton pRipple type="button" icon="pi pi-home" label="Dashboard"
               class="p-button-raised p-button-success mr-10 mT-15" (click)="redirectHome()"></button>
         </span>
         <span>
            <button pButton pRipple type="button" icon="pi pi-user" label="Cuenta"
               class="p-button-raised p-button-success mr-10 mT-15" (click)="redirectaccount()"></button>
         </span>
         <span>
            <button pButton pRipple type="button" icon="pi pi-phone" label="Dispositivos"
               class="p-button-raised p-button-success mr-10 mT-15" (click)="redirectDevice()"></button>
         </span>
         <span>
            <button pButton pRipple type="button" icon="pi pi-comments" label="Chats"
               class="p-button-raised p-button-success mr-10 mT-15" (click)="redirectChats()"></button>
         </span>
      </div> -->
   </div>
   <ng-template pTemplate="footer">
   </ng-template>
   <br />
   <br />
</p-card>